export default __webpack_public_path__ + "static/media/MouseClick01.8edfafd8.mp3";